import * as React from 'react'
import { reduxForm, InjectedFormProps } from 'redux-form'
import { FormGroup, Button } from 'react-bootstrap'

import { FORM_FORGOT_PASSWORD } from '../../constants/Form'
import {
  FORGOT_PASSWORD_FORM_EMAIL
} from '../../constants/ForgotPasswordFormFieldName'
import { InputControlField } from '../../components/form/InputControl'
import { isEmail, isRequired } from '../../utils/validators'

export interface ForgotPasswordFormData {
  email: string
}

export type ForgotPasswordFormProps = InjectedFormProps<ForgotPasswordFormData>

const ForgotPasswordForm: React.SFC<ForgotPasswordFormProps> = ({ handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit}>
      <InputControlField
        label="Email"
        name={FORGOT_PASSWORD_FORM_EMAIL}
        type="text"
        placeholder="Email"
        validate={[isRequired, isEmail]}
      />
      <FormGroup>
        <Button bsStyle="primary" type="submit">
          Odeslat
        </Button>
      </FormGroup>
    </form>
  )
}

export default reduxForm<ForgotPasswordFormData>({
  form: FORM_FORGOT_PASSWORD
})(ForgotPasswordForm)



// WEBPACK FOOTER //
// ./src/screens/forgotPassword/ForgotPasswordForm.tsx